import { NameDto } from 'api/Common/Types'

import { CountryDto } from '../../Identity/Types/Country'
import { CountryOverridesDtoResponse } from './CountryOverridesType'

export interface PlatformConfigurationTypesDto {
  tickmillCompany: NameDto
  platformType: NameDto
  server: NameDto
  demoServer: NameDto
  welcomeServer: NameDto
  mamServer: NameDto
  dynamicLeverage: boolean
}
export interface PlatformConfigurationCountryOverridesTypesDto {
  tickmillCompany: NameDto
  platformType: NameDto
  countriesOverrides: CountryOverridesDtoResponse
  newCountryOverrides: CountryDto
  tradingAllowed: boolean
}

export enum PlatformConfigurationFilterKey {
  TICKMILL_COMPANY = 'TickmillCompany',
  PLATFORM_TYPE = 'PlatformType',
  SERVER = 'Server',
  DEMO_SERVER = 'DemoServer',
  WECLOME_SERVER = 'WelcomeServer',
  MAM_SERVER = 'MamServer',
  DYNAMIC_LEVERAGE = 'DynamicLeverage',
}

export enum PlatformConfigurationKey {
  companyId = 'tickmillCompany.id',
  platformTypeId = 'platformType.id',
  liveServerId = 'server.id',
  demoServerId = 'demoServer.id',
  welcomeServerId = 'welcomeServer.id',
  mamServerId = 'mamServer.id',
  dynamicLeverage = 'dynamicLeverage',
}

export interface AddPlatformConfiguration {
  tickmillCompanyId: number | null
  platformTypeId: number | null
  serverId: string | null
  demoServerId: string | null
  welcomeServerId?: string | null
  mamServerId?: string | null
  dynamicLeverage: boolean | null
}
